import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ROUTES } from "../../../../constants/routes";
import { getSelectedEventsDetails } from "../../../../store/auth/selectors";
import { useCareerCounsellingStatusMutation } from "../../../../store/ApiMutaion";
import "./CareerCounsellingRedirect.css";

const CareerCounsellingRedirect = ({ task }) => {
  const eventDetails = useSelector(getSelectedEventsDetails);
  const [triggerCareerCounsellingStatus] = useCareerCounsellingStatusMutation();
  const [countdown, setCountdown] = useState(10);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  useEffect(() => {
    let timer;
    if (isButtonDisabled && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      setIsButtonDisabled(false);
    }
    return () => clearTimeout(timer);
  }, [countdown, isButtonDisabled]);
  useEffect(() => {
    if (task === "dashboard_redirection" && eventDetails?.event_id) {
      triggerCareerCounsellingStatus(eventDetails.event_id);
    }
  }, [task, eventDetails, triggerCareerCounsellingStatus]);

  const handleDashboardRedirect = () => {
    window.top.location.href = `${window.location.origin}${ROUTES.DASHBOARD}`;
  };

  return (
    <div className="career-counselling-container">
      <div className="career-counselling-card">
        <div className="career-counselling-content">
          <h2>Thank you for your response!</h2>
          <p>Your report will be generated in approximately 2 hrs</p>

          {task === "dashboard_redirection" && (
            <button className="dashboard-redirect-button" onClick={handleDashboardRedirect} disabled={isButtonDisabled}>
              {isButtonDisabled ? `Please wait... (${countdown}s)` : "Go to Dashboard"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CareerCounsellingRedirect;
